import { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Divider } from 'antd';

import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { PopoverCustom as Popover } from '@deprecated-ui/header';

import If from 'global/ErrorHandlers/If';
import Image from 'global/Image';
import SwitchPortfolio from 'features/multi-porto/components/SwitchAccount';

import { getUserLoginStatus } from 'global/Securities/utils/auth';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import useMultiPortfolioStore from 'lib/stores/multiPorto';
import useSubAccounts from 'features/multi-porto/hooks/useSubAccounts';
import useBroadcastChannel, {
  BroadcastMessage,
} from 'hooks/useBroadcastChannel';
import stockTransfer from 'lib/api/stockTransfer';

import realTradingMenu from './realTadingMenu';
import ButtonTradingOutline from './ButtonTradingOutline';
import TradingMenuItem from './TradingMenuItem';

import {
  PopoverContainerBlock,
  StockTransferNotif,
  TradeAreaContent,
  TradingMenuTitle,
  ButtonBuyWrapper,
} from './styled';

const Web = ({ minimize, ...otherProps }) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [lastId, setLastId] = useState<string>(null);
  const [transferNote, setTransferNote] = useState<string>('');
  const openSearchCompanyModal = useSearchCompanyModalStore((s) => s.showModal);

  const { message } = useBroadcastChannel<BroadcastMessage>('multi-portfolio');

  const { activeAccountName } = useSubAccounts();

  const setActiveAccount = useMultiPortfolioStore((s) => s.setActiveAccount);
  const getTradingBalance = useMultiPortfolioStore((s) => s.getTradingBalance);

  useEffect(() => {
    if (getUserLoginStatus()) {
      stockTransfer.getNotification().then((res) => {
        if (res.data.data) {
          const { latest_pending_id, notes } = res.data.data;
          setLastId(latest_pending_id);
          setTransferNote(notes);
        }
      });
    }
  }, []);

  const handleClose = () => {
    setLastId(null);
    setTransferNote('');
  };

  const handleClickNotif = () => {
    handleClose();
    router.push('/securities/stocktransfer');
  };

  const handleBuyClick = () =>
    withMaintenanceGuard(() => {
      openSearchCompanyModal();
      setIsVisible(false);
    });

  const handleChangeVisibility = (active: boolean) => {
    setIsVisible(active);

    if (active) {
      getTradingBalance();
    }
  };

  useEffect(() => {
    if (message && message.type === 'refetch-portfolio') {
      setActiveAccount(message.message);
    }
  }, [message]);

  const stockbitLogoUrl = '/img/ssd.svg';

  return (
    <Popover
      componentTrigger={(isButtonActive: boolean) => (
        <ButtonTradingOutline
          {...otherProps}
          isActive={isButtonActive}
          isOpen={isVisible}
          minimize={minimize}
          label={activeAccountName || 'Trading Area'}
          imageSrc={stockbitLogoUrl}
          onChangeVisibility={handleChangeVisibility}
        />
      )}
    >
      <If condition={isVisible}>
        <PopoverContainerBlock>
          <If condition={lastId}>
            <StockTransferNotif>
              <button
                type="button"
                className="trading-menu-notification"
                onClick={handleClickNotif}
              >
                <Image
                  alt="notification-illustration"
                  src="/images/cloud-document-blue.svg"
                />
                <p>{transferNote}</p>
              </button>
              <button
                type="button"
                className="trading-menu-notification-close"
                onClick={handleClose}
              >
                <Image alt="close-x" src="/icon/x-bold-blue.svg" />
              </button>
            </StockTransferNotif>
          </If>

          <ButtonBuyWrapper>
            <Button
              type="primary"
              height="40px"
              block
              onClick={handleBuyClick}
              style={{ borderRadius: '4px' }}
            >
              <Text
                color={color.light}
                size="14px"
                family="bold"
                align="center"
              >
                BUY
              </Text>
            </Button>
          </ButtonBuyWrapper>

          {realTradingMenu.map(({ title, subMenu }, i) => (
            <TradeAreaContent key={`trade-area-content-${i + 1}`}>
              <If condition={!!title}>
                <TradingMenuTitle>
                  <Text family="bold" color={color.primary}>
                    {title}
                  </Text>
                </TradingMenuTitle>
              </If>

              <If condition={i === 0}>
                <SwitchPortfolio onClick={() => setIsVisible(false)} />
              </If>

              {subMenu.map(
                ({ iconmoonWeb, label, link, flag }, index: number) => (
                  <Fragment key={`trading-menu-item-${index + 1}`}>
                    {!flag && (
                      <TradingMenuItem
                        iconmoon={iconmoonWeb}
                        label={label}
                        link={link}
                      >
                        {label}
                      </TradingMenuItem>
                    )}
                  </Fragment>
                ),
              )}

              <Divider className="divider" />
            </TradeAreaContent>
          ))}
        </PopoverContainerBlock>
      </If>
    </Popover>
  );
};

export default Web;
